const getMilesAway = (distance) => `${Math.round(distance)} mile${Math.round(distance) !== 1 ? 's' : ''} away`;

export default getMilesAway;
